import "./index.scss";
import React, {useContext, useEffect, useState} from 'react';
import {GlobalContext} from '../../context';
import {DEBUG_MODE, ELEMENTS_SHOW_VERSION} from "../../config";
import "react-datepicker/dist/react-datepicker.css";
import {EntryPoint} from "../EntryPoint";
import {EntryFormGroup} from "../EntryFormGroup";
import {FormProvider, useForm} from "react-hook-form";
import {EntryFormItem} from "../EntryFormItem";
import {Loader} from "../Loader";
import {
  filterPages,
  sortPagesAndCreateDefaultValues
} from "../../helper";

const handleSubmit = (responseArray, updateCookies, goToResults) => {
  console.log('EntryComponent handleSubmit', {responseArray});
  // TODO: check for completeness of data :D
  updateCookies(responseArray);
  goToResults();
};

const handleError = (responseArray) => {
  console.log('EntryComponent handleError', {responseArray});
}

function loadDummyData(setResponseArray, setValue) {
  console.log('EntryComponent loadDummyData');
  const dummyData = [
    {
      "key": "gebaeudeTyp",
      "value": 1
    },
    {
      "key": "energieTraeger",
      "value": 1
    },
    {
      "key": "bestehendeBrennstoffversorgung",
      "value": 1
    },
    {
      "key": "zusatzSolar",
      "value": true
    },
    {
      "key": "beheizteFlaeche_type1",
      "value": 100
    },
    {
      "key": "schornstein",
      "value": 2
    }
  ];
  dummyData.forEach((data) => setValue(data.key, data.value));
  setResponseArray(dummyData);
}

export function EntryComponent(props) {
  const [loading, setLoading] = useState(true);
  const [sortedPages, setSortedPages] = useState([]);
  const [filteredPages, setFilteredPages] = useState([]);
  const [values, setValues] = useState();
  const formMethods = useForm({values});
  const {config, pages, updateCookies, goToResults, responseArray, setResponseArray} = useContext(GlobalContext);
  // const {imprintLink, agbLink, privacyLink} = config;

  useEffect(() => {
    setTimeout(function () {
      window.requestAnimationFrame(function () {
        console.log("original height", document.getElementById("maincontainer").clientHeight, document.getElementById("maincontainer").scrollHeight);
        let height = document.getElementById("maincontainer").clientHeight - 300;
        window.parent.postMessage({type: "iframe", message: "resize", height: height}, '*');
        window.scrollTo(0, 0);
        if (ELEMENTS_SHOW_VERSION) {
          window.parent.postMessage({type: "iframe", message: "scrollTo", positionx: 0, positiony: 0}, '*');
        }
      });
    }, 300);
  }, []);

  useEffect(() => {
    if (!pages || pages.length === 0) {
      return;
    }
    console.log('updating pages', {pages});
    sortPagesAndCreateDefaultValues(pages)
      .then(({sortedPages, defaultValues}) => {
        console.log('updating pages - finished', {sortedPages, defaultValues});
        setSortedPages(sortedPages);
        setValues(defaultValues);
      });
  }, [pages, setSortedPages, setLoading, formMethods]);

  useEffect(() => {
    if (!sortedPages || sortedPages.length === 0) {
      return;
    }
    console.log('updating filtered pages', {groups: sortedPages, responseArray});
    filterPages(sortedPages, responseArray)
      .then(filteredPages => {
        setFilteredPages(filteredPages);
        setLoading(false);
      });
  }, [sortedPages, responseArray, setFilteredPages, setLoading]);

  return (
    <div id="maincontainer" className="entry">
      <div className="entry-desc">
        <h2>
          In wenigen Schritten zu Ihrem persönlichen Heizungsangebot
        </h2>
        <p>
          So einfach funktioniert der Heizungsplaner:
        </p>
        <EntryPoint
          num="1"
          title="Heizung konfigurieren"
          desc="Nach Eingabe Ihrer Daten erstellen wir Angebote passend zu Ihrer Wunschkonfiguration."
        />
        <EntryPoint
          num="2"
          title="Angebot auswählen"
          desc="Vergleichen Sie die Ergebnisse und wählen das für Sie passende Angebot aus."
        />
        <EntryPoint
          num="3"
          title="Termin vereinbaren"
          desc="Um einen passenden Termin zu finden, setzen wir uns mit Ihnen in Verbindung."
        />
        <EntryPoint
          num="4"
          title="Heizung montieren"
          desc="Nach abschliessender Prüfung und Auftragserteilung erfolgt die Montage Ihrer Heizung."
        />
      </div>
      <div className="entry-form">
        {loading ? (
          <div className="ef-loading">
            <Loader/>
          </div>
        ) : (
          <FormProvider {...formMethods}>
            <form onSubmit={formMethods.handleSubmit(
              () => handleSubmit(responseArray, updateCookies, goToResults),
              () => handleError(responseArray),
            )}>
              <h4>Jetzt Heizung konfigurieren</h4>
              {/*{groups.map((group, groupIndex) => (*/}
              {/*    <EntryFormGroup*/}
              {/*        key={groupIndex}*/}
              {/*        icon={group.icon}*/}
              {/*        title={group.name}*/}
              {/*    >*/}
              <div className="efg-container">
                {filteredPages.map((entry, entryIndex) => (
                  <EntryFormItem
                    key={entryIndex}
                    page={entry}
                  />
                ))}
              </div>
              {/*    </EntryFormGroup>*/}
              {/*))}*/}
              <div className="entry-form-footer">
                {/*<div className="mr-4 eff-link">*/}
                {/*    <a href={imprintLink || agbLink} target="_blank">Impressum</a>*/}
                {/*</div>*/}
                {/*<div className="eff-link">*/}
                {/*    <a href={privacyLink} target="_blank"> Datenschutzerklärung</a>*/}
                {/*</div>*/}
                {/*<div className="flex-grow-1">&nbsp;</div>*/}
                <button type="submit" className="btn custom-button">
                  Angebote Finden
                </button>
              </div>
            </form>
          </FormProvider>
        )}
        {DEBUG_MODE && (
          <button type="button" className="btn btn-primary" onClick={() => loadDummyData(setResponseArray, formMethods.setValue)}>
            load dummy data
          </button>
        )}
      </div>
    </div>
  )
}
